module.exports = __webpack_public_path__ + "img/doublechevron-left-11022022.892ddf90.svg";